










import BaseStringInput from "@web-components/components/BaseStringInput.vue";
import { createComponent } from "@vue/composition-api";
import { emailRegEx } from "../common/regex";

export default createComponent({
  components: {
    BaseStringInput
  },
  props: {
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    }
  },
  setup(props: {}, { emit }) {
    const handleInput = (value: string) => {
      emit("input", value);
    };
    const handleValidation = (value: ValidityState) => {
      emit("validation", value);
    };
    return {
      emailRegEx,
      handleInput,
      handleValidation
    };
  }
});
